<div class="flex flex-col gap-2">
  <div style="height: 24px" [style.visibility]="breadcrumbs().length ? 'visible' : 'hidden'">
    <xemex-breadcrumb [items]="breadcrumbs()" [loading]="loading()" />
  </div>
  <div class="flex items-center gap-4">
    @if (loading()) {
      <xemex-skeleton-block width="56px" height="56px" borderRadius="8px" />
    } @else if (imageUrl() || icon()) {
      <div class="page-header__avatar shrink-0">
        @if (imageUrl()) {
          <img
            xemexFetchImage
            [src]="imageUrl()"
            (imageResolved)="imageLoaded.set($event)"
            [class.hidden]="!imageLoaded()"
            class="page-header__avatar-img"
            alt=""
          />
        }
        @if (!imageLoaded() && icon()) {
          <mat-icon
            class="page-header__avatar-icon"
            [fontSet]="iconOutlined() ? 'material-icons-outlined' : ''"
            >{{ icon() }}</mat-icon
          >
        }
      </div>
    }
    <div class="flex-1 min-w-0">
      @if (loading()) {
        <div class="flex flex-col gap-2">
          <xemex-skeleton-block width="220px" height="28px" />
          <xemex-skeleton-block width="120px" height="16px" />
        </div>
      } @else {
        <h2
          class="title text-gray-900 truncate"
          [class.has-subtitle]="subtitle() && titleSize() === 'auto'"
        >
          {{ title() }}
        </h2>
        @if (badgesBesideSubtitle()) {
          <div class="flex items-center gap-2 min-w-0">
            @if (subtitle()) {
              <p class="text-sm text-gray-500 truncate">{{ subtitle() }}</p>
            }
            <ng-container *ngTemplateOutlet="badgeList" />
          </div>
        } @else if (subtitle()) {
          <p class="text-sm text-gray-500">{{ subtitle() }}</p>
        }
      }
    </div>
    <div class="flex items-center gap-3 shrink-0">
      @if (!badgesBesideSubtitle()) {
        <ng-container *ngTemplateOutlet="badgeList" />
      }
      @if (!loading()) {
        <ng-content select="[actions]" />
      }
    </div>
  </div>
  <ng-content />
</div>

<ng-template #badgeList>
  @if (badges().length) {
    <div
      class="page-header__badges flex items-center gap-2"
      [class.page-header__badges--inline]="badgesBesideSubtitle()"
    >
      @for (badge of badges(); track badge.label) {
        <xemex-status-chip
          [status]="badge.status"
          [label]="badge.label"
          [icon]="badge.icon"
          [size]="badgeSize()"
        />
      }
    </div>
  }
</ng-template>
